import React, { useContext } from 'react'
import ContentDetail from './contentDetail'
import { isEmpty } from 'lodash'
import { TemplateContext } from '../../context/template'
import NewContentDetail from './newContentDetail'
import ContentDetailPageB from './contentDetailPages/contentDetailPageB'
import DefaultContentDetailPage from './contentDetailPages/defaultContentDetailPage'

const ContentDetailTemplate = () => {
  const { contentDetailTemplateData, contentTemplateLoaded } = useContext(TemplateContext)

  const getPage = (key, data) => {
    if (!key) return
    let pageProps = {
      // data: { ...data, aligned: 'LEFT' },
      data,
      modifyData: () => {},
      setModalState: () => {},
      isEdit: false,
    }
    let componentObj = {
      newContentDetail: <NewContentDetail {...pageProps} />,
      contentDetailB: <ContentDetailPageB {...pageProps} />,
      defaultContentDetail: <DefaultContentDetailPage {...pageProps} />,
    }

    return componentObj[key]
  }
  return (
    <div className="w-full h-full">
      {contentTemplateLoaded ? (
        !isEmpty(contentDetailTemplateData) ? (
          getPage(contentDetailTemplateData.template_key, contentDetailTemplateData.data)
        ) : (
          <ContentDetail />
        )
      ) : null}
    </div>
  )
}

export default ContentDetailTemplate
